                                  
import { openMeldRuntimeProfileIdSchema, profileHandleSchema, profileKindSchema, profileLabelSchema } from "../protocol/profile.js";
import * as z$1 from "zod/v4";
//#region src/schemas/daemon/profile-identity.ts
const nonEmptyTextSchema = z$1.string().transform((value) => value.trim()).refine((value) => value.length > 0, "Expected non-blank text");
const OPENMELD_SYSTEM_PROFILE_ID = "openmeld-system";
const openMeldSystemProfileIdSchema = z$1.literal(OPENMELD_SYSTEM_PROFILE_ID);
const openMeldActorProfileIdSchema = z$1.union([openMeldRuntimeProfileIdSchema, openMeldSystemProfileIdSchema]);
const visitedProfileIdsSchema = z$1.array(openMeldRuntimeProfileIdSchema).max(256);
const openMeldProfileIdSchema = openMeldRuntimeProfileIdSchema;
const resolvedOpenMeldProfileSchema = z$1.strictObject({
	openMeldProfileId: openMeldProfileIdSchema,
	profileKind: profileKindSchema,
	profileName: profileLabelSchema,
	ownerUserId: nonEmptyTextSchema,
	profileHandle: profileHandleSchema.optional(),
	ownerName: profileLabelSchema.optional(),
	agentControllerRef: nonEmptyTextSchema.optional(),
	avatarUrl: z$1.string().min(1).optional()
});
const openMeldActorContextSchema = z$1.strictObject({
	requestId: nonEmptyTextSchema,
	callerPrincipalId: nonEmptyTextSchema.optional(),
	openMeldProfileId: openMeldActorProfileIdSchema,
	profileKind: profileKindSchema,
	profileHandle: profileHandleSchema.optional(),
	profileName: profileLabelSchema.optional(),
	ownerUserId: nonEmptyTextSchema.optional(),
	ownerName: profileLabelSchema.optional(),
	avatarUrl: z$1.string().min(1).optional(),
	agentControllerRef: nonEmptyTextSchema.optional(),
	dispatchChainId: nonEmptyTextSchema.optional(),
	autoRelayDepth: z$1.number().int().nonnegative().optional(),
	visitedProfileIds: visitedProfileIdsSchema.optional(),
	visitedProfileIdsHash: nonEmptyTextSchema.optional()
}).superRefine((value, ctx) => {
	if (value.profileKind === "system") {
		if (value.openMeldProfileId !== OPENMELD_SYSTEM_PROFILE_ID) ctx.addIssue({
			code: "custom",
			message: "system actor context must use openmeld-system as openMeldProfileId",
			path: ["openMeldProfileId"]
		});
		return;
	}
	if (!openMeldRuntimeProfileIdSchema.safeParse(value.openMeldProfileId).success) ctx.addIssue({
		code: "custom",
		message: "human/agent actor context must use an auth-backed OpenMeld runtime profile ID",
		path: ["openMeldProfileId"]
	});
});
const openMeldRequestContextSchema = z$1.strictObject({
	actorContext: openMeldActorContextSchema,
	activeOrganizationId: nonEmptyTextSchema.optional(),
	agentControllerConversationId: nonEmptyTextSchema.optional()
});
//#endregion
export { openMeldActorContextSchema, openMeldProfileIdSchema, openMeldRequestContextSchema, resolvedOpenMeldProfileSchema };

//# sourceMappingURL=profile-identity.js.map